import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  user:{},
  isAuthenticated : false, 
  acesssToken:"",
  sessionExpired: false,
  branding: {
    logoUrl: "",
    logoWidth: 96,
    logoHeight: 96,
    loaded: false
  }

}

const  AppState = createSlice({
  name: 'appState',
  initialState,
  reducers: {
     setUser: (state,action) => {     
  state.user = action.payload;
},
setIsAuthenticated: (state,action) => {     
  state.isAuthenticated  = action.payload;
},
setAccessToken: (state,action) => {     
  state.acesssToken  = action.payload;
},
setSessionExpired: (state,action) => {     
  state.sessionExpired = action.payload;
},
setBranding: (state, action) => {
  state.branding = {
    logoUrl: action.payload?.logoUrl || "",
    logoWidth: Number(action.payload?.logoWidth) || 96,
    logoHeight: Number(action.payload?.logoHeight) || 96,
    loaded: true
  };
},
},
})

export const {setUser,setIsAuthenticated,setAccessToken,setSessionExpired,setBranding} = AppState.actions

export default AppState.reducer
